import React, { useEffect, useState } from "react";
import query, { data } from "jquery";
import { Link, NavLink, useLocation } from "react-router-dom";
import { errorAlert, successAlert } from "../apiService/sweetAlert";

import { apiRequest } from "../apiService/allapi";
import { getTotalCartCount } from "../helper/cartUtils";

const getAuthToken = () => {
  const token = localStorage.getItem("token");
  return token && token !== "undefined" && token !== "null" ? token : "";
};

const Header = () => {
  const [authToken, setAuthToken] = useState(getAuthToken());
  const isLoggedIn = Boolean(authToken);
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("Eng");
  const [selectedCurrency, setSelectedCurrency] = useState("USD");

  const [cartCount, setCartCount] = useState(0);

  const [scroll, setScroll] = useState(false);
  const [activeSearch, setActiveSearch] = useState(false);
  const [activeCategory, setActiveCategory] = useState(false);
  // const [activeIndexCat, setActiveIndexCat] = useState(null);
  const [menuActive, setMenuActive] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [wishlistCount, setWishlistCount] = useState(0);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState("");
  // const [categories, setCategories] = useState();
  // const [subCategories, setsubCategories] = useState([]);
  // const [categoryId, setCategoryId] = useState(1);
  // const [subsubCategories, setsubsubCategories] = useState([]);
  // const [subcategoryId, subsetCategoryId] = useState(1);
  // const [scid, setScid] = useState(null);

  // length according cart count
  // const getCartCount = async () => {
  //   try {
  //     const token = localStorage.getItem("token");
  //     if (!token) {
  //       setCartCount(0);
  //       return;
  //     }

  //     const res = await apiRequest("/Cart/list", "GET", null, {
  //       Authorization: `Bearer ${token}`,
  //     });

  //     if (res?.data?.status === true) {
  //       setCartCount(res.data.data.data?.length || 0);
  //     } else {
  //       setCartCount(0);
  //     }
  //   } catch (error) {
  //     console.log("Cart count error:", error);
  //     setCartCount(0);
  //   }
  // };

  // useEffect(() => {
  //   getCartCount();
  // }, []);
  // 🔥 UPDATED: Universal cart count (guest + server)
  const getCartCount = async () => {
    try {
      const total = await getTotalCartCount();
      setCartCount(total);
    } catch (error) {
      console.log("Cart count error:", error);
      setCartCount(0);
    }
  };

  useEffect(() => {
    getCartCount();
  }, []);

  useEffect(() => {
    const syncAuthState = () => {
      setAuthToken(getAuthToken());
      getCartCount();
      getWishlistCount();
      getAddresses();
    };

    window.addEventListener("storage", syncAuthState);
    window.addEventListener("userLoggedIn", syncAuthState);
    window.addEventListener("userLoggedOut", syncAuthState);

    return () => {
      window.removeEventListener("storage", syncAuthState);
      window.removeEventListener("userLoggedIn", syncAuthState);
      window.removeEventListener("userLoggedOut", syncAuthState);
    };
  }, []);

  // 🔥 NEW: Listen for cart updates
  useEffect(() => {
    const handleCartUpdate = () => {
      getCartCount();
    };

    window.addEventListener("cartCountUpdated", handleCartUpdate);
    return () => {
      window.removeEventListener("cartCountUpdated", handleCartUpdate);
    };
  }, []);
  // wishlist
  const location = useLocation();
  useEffect(() => {
    const handleWishlistUpdate = () => {
      getWishlistCount();
    };

    window.addEventListener("wishlistUpdated", handleWishlistUpdate);

    return () => {
      window.removeEventListener("wishlistUpdated", handleWishlistUpdate);
    };
  }, []);
  useEffect(() => {
    window.onscroll = () => {
      if (window.pageYOffset < 150) {
        setScroll(false);
      } else if (window.pageYOffset > 150) {
        setScroll(true);
      }
      return () => (window.onscroll = null);
    };
    const selectElement = query(".js-example-basic-single");
    selectElement.select2();

    return () => {
      if (selectElement.data("select2")) {
        selectElement.select2("destroy");
      }
    };
  }, []);
  useEffect(() => {
    const handleAddressUpdate = () => {
      getAddresses(); // 🔥 refresh header dropdown
    };

    window.addEventListener("addressUpdated", handleAddressUpdate);

    return () => {
      window.removeEventListener("addressUpdated", handleAddressUpdate);
    };
  }, []);

  // Set the default language
  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
  };

  // Set the default currency
  const handleCurrencyChange = (currency) => {
    setSelectedCurrency(currency);
  };

  // Mobile menu support

  const handleMenuClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const handleMenuToggle = () => {
    setMenuActive(!menuActive);
  };

  // Search control support
  const handleSearchToggle = () => {
    setActiveSearch(!activeSearch);
  };

  // const handleCategoryToggle = () => {
  //   setActiveCategory(!activeCategory);
  // };
  // const handleCatClick = (index) => {
  //   setActiveIndexCat(activeIndexCat === index ? null : index);
  // };

  // const getCategories = async () => {
  //   try {
  //     setLoading(true);

  //     const res = await apiRequest("/Category/category/list", "GET");

  //     if (res?.data?.status === 1) {
  //       setLoading(false);
  //       setCategories(res.data.data);

  //       return true;
  //     } else {
  //       setLoading(false);
  //       errorAlert(res.data.message);

  //       return false;
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     setLoading(false);
  //     return false;
  //   }
  // };

  // useEffect(() => {
  //   getCategories();
  // }, []);

  // const subCategoriesApi = async (cid) => {
  //   try {
  //     setLoading(true);

  //     const res = await apiRequest(`/Category/subcategory/list/${cid}`, "GET");
  //     if (res?.data?.status === 1) {
  //       setsubCategories(res.data.data);
  //     } else {
  //       errorAlert(res.data.message);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   if (categoryId) {
  //     subCategoriesApi(categoryId);
  //   }
  // }, [categoryId]);

  // const subsubCategoriesApi = async (cid, scid) => {
  //   console.log("Calling API:", cid, scid);

  //   try {
  //     setLoading(true);

  //     const res = await apiRequest(
  //       `/Category/subtosubcategory/list/${cid}/${scid}`,
  //       "GET",
  //     );

  //     console.log("Response:", res);

  //     if (res?.data?.status === 1) {
  //       setsubsubCategories(res.data.data);
  //     }
  //   } catch (error) {
  //     console.log("API Error:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  //  useEffect(() => {
  //   if (categoryId && scid) {
  //     subsubCategoriesApi(categoryId, scid);
  //   }
  // }, [categoryId, scid]);
  const getWishlistCount = async () => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        setWishlistCount(0);
        return;
      }

      const res = await apiRequest("/Wishlist/getToggle", "GET", null, {
        Authorization: `Bearer ${token}`,
      });

      if (res?.data?.status === true) {
        const wishlistItems = res?.data?.data || [];
        setWishlistCount(wishlistItems.length);
      } else {
        setWishlistCount(0);
        console.log("Wishlist API failed or empty:", res?.data); // Debug
      }
    } catch (error) {
      console.log("Wishlist count error:", error);
      setWishlistCount(0);
    }
  };

  const getAddresses = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setAddresses([]);
        return;
      }

      const res = await apiRequest("/User/get-addresses", "GET", null, {
        Authorization: `Bearer ${token}`,
      });

      if (res?.data?.status === true) {
        const list = res.data.data || [];

        setAddresses([...list]); // 🔥 force new reference

        const defaultAddr = list.find((a) => a.isDefault);
        if (defaultAddr) {
          setSelectedAddressId(defaultAddr.id);
        } else if (list.length > 0) {
          setSelectedAddressId(list[0].id);
        }
      } else {
        setAddresses([]);
      }
    } catch (error) {
      console.log("Addresses error:", error);
      setAddresses([]);
    }
  };
  useEffect(() => {
    getAddresses(); // initial load

    const handleAddressUpdate = () => {
      // console.log("Header updated 🔥");
      getAddresses(); // 🔥 refresh on event
    };

    window.addEventListener("addressUpdated", handleAddressUpdate);

    return () => {
      window.removeEventListener("addressUpdated", handleAddressUpdate);
    };
  }, []); // ❌ dependency mat daalo

  useEffect(() => {
    getCartCount();
    getWishlistCount();
    // getAddresses();
  }, []);
  const handleSetDefault = async (id) => {
    try {
      const token = localStorage.getItem("token");

      const res = await apiRequest(
        `/User/SetDefaultAddress?addressId=${id}`, // ✅ correct
        "POST",
        null,
        {
          Authorization: `Bearer ${token}`,
        },
      );

      if (res?.data?.status === true) {
        getAddresses(); // 👈 make sure ye bhi hai header me
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleAddressChange = async (id) => {
    try {
      setSelectedAddressId(id);

      const token = localStorage.getItem("token");

      const res = await apiRequest(
        `/User/SetDefaultAddress?addressId=${id}`,
        "POST",
        null,
        {
          Authorization: `Bearer ${token}`,
        },
      );

      if (res?.data?.status === true) {
        await getAddresses(); // ✅ BEST FIX
        window.dispatchEvent(new Event("addressUpdated"));
      }
    } catch (err) {
      console.log(err);
    }
  };

  // post methode
  const handleDashboardRedirect = () => {
    const token = localStorage.getItem("token"); // ya jahan token store hai

    const form = document.createElement("form");
    form.method = "POST";
    form.action = "https://airdealindia.com/User/Dashboard.aspx";

    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "access_token";
    input.value = token;

    form.appendChild(input);
    document.body.appendChild(form);

    form.submit();
  };

  return (
    <>
      <div className="overlay" />
      <div
        className={`side-overlay ${(menuActive || activeCategory) && "show"}`}
      />
      {/* ==================== Search Box Start Here ==================== */}
      <form action="#" className={`search-box ${activeSearch && "active"}`}>
        <button
          onClick={handleSearchToggle}
          type="button"
          className="search-box__close position-absolute inset-block-start-0 inset-inline-end-0 m-16 w-48 h-48 border border-gray-100 rounded-circle flex-center text-white hover-text-gray-800 hover-bg-white text-2xl transition-1"
        >
          <i className="ph ph-x" />
        </button>
        <div className="container">
          <div className="position-relative">
            <input
              type="text"
              className="form-control py-16 px-24 text-xl rounded-pill pe-64"
              placeholder="Search for a product or brand"
            />
            <button
              type="submit"
              className="w-48 h-48 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
            >
              <i className="ph ph-magnifying-glass" />
            </button>
          </div>
        </div>
      </form>
      {/* ==================== Search Box End Here ==================== */}
      {/* ==================== Mobile Menu Start Here ==================== */}
      <div
        className={`mobile-menu scroll-sm d-lg-none d-block ${menuActive && "active"}`}
      >
        <button
          onClick={() => {
            handleMenuToggle();
            setActiveIndex(null);
          }}
          type="button"
          className="close-button"
        >
          <i className="ph ph-x" />{" "}
        </button>
        <div className="mobile-menu__inner">
          <Link to="/" className="mobile-menu__logo">
            <img src="/assets/images/logo/logo.png" alt="Logo" />
          </Link>
          <div className="mobile-menu__menu">
            {/* Nav Menu Start */}
            <ul className="nav-menu flex-align nav-menu--mobile">
              {/* Home Menu */}
              <li
                onClick={() => handleMenuClick(0)}
                className={`on-hover-item nav-menu__item has-submenu ${
                  activeIndex === 0 ? "d-block" : ""
                }`}
              >
                <Link to="#" className="nav-menu__link">
                  Home
                </Link>
                <ul
                  className={`on-hover-dropdown common-dropdown nav-submenu scroll-sm ${
                    activeIndex === 0 ? "open" : ""
                  }`}
                >
                  <li className="common-dropdown__item nav-submenu__item">
                    <Link
                      to="/"
                      className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                      onClick={() => setActiveIndex(null)}
                    >
                      {" "}
                      Home One
                    </Link>
                  </li>
                  <li className="common-dropdown__item nav-submenu__item">
                    <Link
                      to="/index-two"
                      className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                      onClick={() => setActiveIndex(null)}
                    >
                      {" "}
                      Home Two
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Shop Menu */}
              <li
                onClick={() => handleMenuClick(1)}
                className={`on-hover-item nav-menu__item has-submenu ${
                  activeIndex === 1 ? "d-block" : ""
                }`}
              >
                <Link to="#" className="nav-menu__link">
                  Shop
                </Link>
                <ul
                  className={`on-hover-dropdown common-dropdown nav-submenu scroll-sm ${
                    activeIndex === 1 ? "open" : ""
                  }`}
                >
                  <li className="common-dropdown__item nav-submenu__item">
                    <Link
                      to="/shop"
                      className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                      onClick={() => setActiveIndex(null)}
                    >
                      {" "}
                      Shop
                    </Link>
                  </li>
                  <li className="common-dropdown__item nav-submenu__item">
                    <Link
                      to="/product-details"
                      className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                      onClick={() => setActiveIndex(null)}
                    >
                      {" "}
                      Shop Details
                    </Link>
                  </li>
                  <li className="common-dropdown__item nav-submenu__item">
                    <Link
                      to="/product-details-two"
                      className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                      onClick={() => setActiveIndex(null)}
                    >
                      {" "}
                      Shop Details Two
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Pages Menu */}
              <li
                onClick={() => handleMenuClick(2)}
                className={`on-hover-item nav-menu__item has-submenu ${
                  activeIndex === 2 ? "d-block" : ""
                }`}
              >
                <span className="badge-notification bg-warning-600 text-white text-sm py-2 px-8 rounded-4">
                  New
                </span>
                <Link to="#" className="nav-menu__link">
                  Pages
                </Link>
                <ul
                  className={`on-hover-dropdown common-dropdown nav-submenu scroll-sm ${
                    activeIndex === 2 ? "open" : ""
                  }`}
                >
                  <li className="common-dropdown__item nav-submenu__item">
                    <Link
                      to="/cart"
                      className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                      onClick={() => setActiveIndex(null)}
                    >
                      {" "}
                      Cart
                    </Link>
                  </li>
                  <li className="common-dropdown__item nav-submenu__item">
                    <Link
                      to="/checkout"
                      className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                      onClick={() => setActiveIndex(null)}
                    >
                      {" "}
                      Checkout{" "}
                    </Link>
                  </li>
                  <li className="common-dropdown__item nav-submenu__item">
                    <Link
                      to={isLoggedIn ? "/user" : "/account"}
                      className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                      onClick={() => {
                        setActiveIndex(null);
                        setMenuActive(false);
                      }}
                    >
                      {isLoggedIn ? "User" : "Login"}
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Blog Menu */}
              <li
                onClick={() => handleMenuClick(3)}
                className={`on-hover-item nav-menu__item has-submenu ${
                  activeIndex === 3 ? "d-block" : ""
                }`}
              >
                <Link to="#" className="nav-menu__link">
                  Blog
                </Link>
                <ul
                  className={`on-hover-dropdown common-dropdown nav-submenu scroll-sm ${
                    activeIndex === 3 ? "open" : ""
                  }`}
                >
                  <li className="common-dropdown__item nav-submenu__item">
                    <Link
                      to="/blog"
                      className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                      onClick={() => setActiveIndex(null)}
                    >
                      {" "}
                      Blog
                    </Link>
                  </li>
                  <li className="common-dropdown__item nav-submenu__item">
                    <Link
                      to="/blog-details"
                      className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                      onClick={() => setActiveIndex(null)}
                    >
                      {" "}
                      Blog Details
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Contact Us Menu */}
              <li className="nav-menu__item">
                <Link
                  to="/contact"
                  className="nav-menu__link"
                  onClick={() => setActiveIndex(null)}
                >
                  Contact Us
                </Link>
              </li>
            </ul>
            {/* Nav Menu End */}
          </div>
        </div>
      </div>
      {/* ==================== Mobile Menu End Here ==================== */}
      {/* ======================= Middle Top Start ========================= */}
      <div className="header-top bg-main-600 flex-between">
        <div className="container container-lg">
          <div className="flex-between flex-wrap gap-8">
            <ul className="flex-align flex-wrap d-none d-md-flex">
              {/* <li className="border-right-item">
                <Link
                  to="#"
                  className="text-white text-sm hover-text-decoration-underline"
                >
                  Become A Seller
                </Link>
              </li> */}
              {/* <li className="border-right-item">
                <Link
                  to="#"
                  className="text-white text-sm hover-text-decoration-underline"
                >
                  About us
                </Link>
              </li> */}
              {/* <li className="border-right-item">
                <Link
                  to="#"
                  className="text-white text-sm hover-text-decoration-underline"
                >
                  Free Delivery
                </Link>
              </li> */}
              {/* <li className="border-right-item">
                <Link
                  to="#"
                  className="text-white text-sm hover-text-decoration-underline"
                >
                  Returns Policy
                </Link>
              </li> */}
            </ul>
            <ul className="header-top__right flex-align flex-wrap">
              {/* <li className="on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white">
                <Link to="#" className="text-white text-sm py-8">
                  Help Center
                </Link>
                <ul className="on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
                  <li className="nav-submenu__item">
                    <Link
                      to="#"
                      className="nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                    >
                      <span className="text-sm d-flex">
                        <i className="ph ph-headset" />
                      </span>
                      Call Center
                    </Link>
                  </li>
                  <li className="nav-submenu__item">
                    <Link
                      to="#"
                      className="nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                    >
                      <span className="text-sm d-flex">
                        <i className="ph ph-chat-circle-dots" />
                      </span>
                      Live Chat
                    </Link>
                  </li>
                </ul>
              </li> */}
              {/* <li className="on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white">
                <Link to="#" className="selected-text text-white text-sm py-8">
                  {selectedLanguage}
                </Link>
                <ul className="selectable-text-list on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
                  <li>
                    <Link
                      to="#"
                      className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                      onClick={() => handleLanguageChange("English")}
                    >
                      <img
                        src="assets/images/thumbs/flag1.png"
                        alt=""
                        className="w-16 h-12 rounded-4 border border-gray-100"
                      />
                      English
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                      onClick={() => handleLanguageChange("Japan")}
                    >
                      <img
                        src="assets/images/thumbs/flag2.png"
                        alt=""
                        className="w-16 h-12 rounded-4 border border-gray-100"
                      />
                      Japan
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                      onClick={() => handleLanguageChange("French")}
                    >
                      <img
                        src="assets/images/thumbs/flag3.png"
                        alt=""
                        className="w-16 h-12 rounded-4 border border-gray-100"
                      />
                      French
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                      onClick={() => handleLanguageChange("Germany")}
                    >
                      <img
                        src="assets/images/thumbs/flag4.png"
                        alt=""
                        className="w-16 h-12 rounded-4 border border-gray-100"
                      />
                      Germany
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                      onClick={() => handleLanguageChange("Bangladesh")}
                    >
                      <img
                        src="assets/images/thumbs/flag6.png"
                        alt=""
                        className="w-16 h-12 rounded-4 border border-gray-100"
                      />
                      Bangladesh
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                      onClick={() => handleLanguageChange("South Korea")}
                    >
                      <img
                        src="assets/images/thumbs/flag5.png"
                        alt=""
                        className="w-16 h-12 rounded-4 border border-gray-100"
                      />
                      South Korea
                    </Link>
                  </li>
                </ul>
              </li> */}
              {/* <li className="on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white">
                <Link to="#" className="selected-text text-white text-sm py-8">
                  {selectedCurrency}
                </Link>
                <ul className="selectable-text-list on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
                  <li>
                    <Link
                      to="#"
                      className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                      onClick={() => handleCurrencyChange("USD")}
                    >
                      <img
                        src="assets/images/thumbs/flag1.png"
                        alt=""
                        className="w-16 h-12 rounded-4 border border-gray-100"
                      />
                      USD
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                      onClick={() => handleCurrencyChange("Yen")}
                    >
                      <img
                        src="assets/images/thumbs/flag2.png"
                        alt=""
                        className="w-16 h-12 rounded-4 border border-gray-100"
                      />
                      Yen
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                      onClick={() => handleCurrencyChange("Franc")}
                    >
                      <img
                        src="assets/images/thumbs/flag3.png"
                        alt=""
                        className="w-16 h-12 rounded-4 border border-gray-100"
                      />
                      Franc
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                      onClick={() => handleCurrencyChange("EURO")}
                    >
                      <img
                        src="assets/images/thumbs/flag4.png"
                        alt=""
                        className="w-16 h-12 rounded-4 border border-gray-100"
                      />
                      EURO
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                      onClick={() => handleCurrencyChange("BDT")}
                    >
                      <img
                        src="assets/images/thumbs/flag6.png"
                        alt=""
                        className="w-16 h-12 rounded-4 border border-gray-100"
                      />
                      BDT
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                      onClick={() => handleCurrencyChange("WON")}
                    >
                      <img
                        src="assets/images/thumbs/flag5.png"
                        alt=""
                        className="w-16 h-12 rounded-4 border border-gray-100"
                      />
                      WON
                    </Link>
                  </li>
                </ul>
              </li> */}
              <li className="border-right-item">
                {isLoggedIn ? (
                  <>
                    <Link
                      to="/user"
                      className="text-white text-sm py-8 flex-align gap-6"
                    >
                      <span className="icon text-md d-flex">
                        <i className="ph ph-user-circle" />
                      </span>
                      <span className="hover-text-decoration-underline">
                        Profile
                      </span>
                    </Link>
                   
                    

                      <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleDashboardRedirect();
                      }}
                      className="text-white text-sm py-8 flex-align gap-6"
                    >
                      <span className="icon text-md d-flex">
                        <i className="ph ph-user-circle" />
                      </span>
                      <span className="hover-text-decoration-underline">
                        Dashboard
                      </span>
                    </a>
<Link
                      to={{
                        pathname:
                          "https://airdealindia.com/Franchise/Login.aspx",
                      }}
                      // target="_blank"
                      className="text-white text-sm py-8 flex-align gap-6"
                    >
                      <span className="icon text-md d-flex">
                        <i className="ph ph-user-circle" />
                      </span>
                      <span className="hover-text-decoration-underline">
                        Franchise Login
                      </span>
                    </Link>
                    {/* <button
                      onClick={() => {
                        localStorage.removeItem("token");
                        window.location.href = "/account";
                      }}
                      className="text-white text-sm py-8 flex-align gap-6 ms-2"
                    >
                      <i className="ph ph-sign-out text-md" />
                    </button> */}
                  </>
                ) : (
                  <>
                  
                  
                  <Link
                    to="/account"
                    className="text-white text-sm py-8 flex-align gap-6"
                  >
                    <span className="icon text-md d-flex">
                      <i className="ph ph-user-circle" />
                    </span>
                    <span className="hover-text-decoration-underline">
                      Login
                    </span>
                  </Link>

                 <Link
                      to={{
                        pathname:
                          "https://airdealindia.com/Franchise/Login.aspx",
                      }}
                      // target="_blank"
                      className="text-white text-sm py-8 flex-align gap-6"
                    >
                      <span className="icon text-md d-flex">
                        <i className="ph ph-user-circle" />
                      </span>
                      <span className="hover-text-decoration-underline">
                        Franchise Login
                      </span>
                    </Link>
                  </>

                  
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* ======================= Middle Top End ========================= */}
      {/* ======================= Middle Header Start ========================= */}
      <header className="header-middle bg-color-one border-bottom border-gray-100">
        <div className="container container-lg">
          <nav className="header-inner flex-between">
            {/* Logo Start */}
            <div className="logo">
              <Link to="/" className="link">
                <img src="/assets/images/logo/logo.png" alt="Logo" />
              </Link>
            </div>
            {/* Logo End  */}
            {/* form location Start */}
            <form
              action="#"
              className="flex-align flex-wrap form-location-wrapper"
            >
              <div className="search-category d-flex h-48 select-border-end-0 radius-end-0 search-form d-sm-flex d-none">
                <div className="search-form__wrapper position-relative">
                  <input
                    type="text"
                    className="search-form__input common-input py-13 ps-16 pe-18 rounded-pill pe-44"
                    placeholder="Search for a product or brand"
                  />
                  <button
                    type="submit"
                    className="w-32 h-32 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
                  >
                    <i className="ph ph-magnifying-glass" />
                  </button>
                </div>
              </div>
              {/* 🔥 Sirf ye part hide hoga */}
              {isLoggedIn && (
                <div className="location-box bg-white flex-align gap-8 py-6 px-16 rounded-pill border border-gray-100">
                  <span className="text-gray-900 text-xl d-xs-flex d-none">
                    <i className="ph ph-map-pin" />
                  </span>
                  <div className="line-height-1">
                    <span className="text-gray-600 text-xs">Your Location</span>
                    <div className="line-height-1">
                      <select
                        value={selectedAddressId || ""}
                        onChange={(e) => handleAddressChange(e.target.value)}
                        className="border-0 border-gray-0 border-end-0"
                      >
                        {addresses.length === 0 ? (
                          <option value="">No addresses</option>
                        ) : (
                          addresses.map((addr) => (
                            <option key={addr.id} value={addr.id}>
                              {`${addr.address || ""}, ${addr.cityName || ""}, ${addr.stateName || ""}`}
                            </option>
                          ))
                        )}
                      </select>
                    </div>
                  </div>
                </div>
              )}
            </form>
            {/* form location start */}
            {/* Header Middle Right start */}
            <div className="header-right flex-align">
              <div className="flex-align flex-wrap gap-12">
                <button
                  onClick={handleSearchToggle}
                  type="button"
                  className="search-icon flex-align d-lg-none d-flex gap-4 item-hover"
                >
                  <span className="text-2xl text-gray-700 d-flex position-relative item-hover__text">
                    <i className="ph ph-magnifying-glass" />
                  </span>
                </button>
                <Link
                  to={isLoggedIn ? "/user" : "/account"}
                  className="flex-align gap-4 item-hover d-lg-none"
                  aria-label={isLoggedIn ? "User" : "Login"}
                >
                  <span className="text-2xl text-gray-700 d-flex position-relative item-hover__text">
                    <i className="ph ph-user-circle" />
                  </span>
                  <span className="text-sm text-gray-700 item-hover__text">
                    {isLoggedIn ? "" : ""}
                  </span>
                </Link>
                {isLoggedIn && (
                  <Link to="/wishlist" className="flex-align gap-4 item-hover">
                    <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                      <i className="ph ph-heart" />
                      <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                        {wishlistCount}
                      </span>
                    </span>
                    <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                      Wishlist
                    </span>
                  </Link>
                )}
                <Link to="/cart" className="flex-align gap-4 item-hover">
                  <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                    <i className="ph ph-shopping-cart-simple" />
                    <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                      {cartCount}
                    </span>
                  </span>
                  <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                    Cart
                  </span>
                </Link>
                {/* <button
                  onClick={handleMenuToggle}
                  type="button"
                  className="toggle-mobileMenu d-lg-none text-gray-800 text-4xl d-flex border-0 bg-transparent p-0"
                  aria-label="Open menu"
                >
                  <i className="ph ph-list" />
                </button> */}
              </div>
            </div>
            {/* Header Middle Right End  */}
          </nav>
        </div>

        <div className="navigation-wrapper">
          <div className="container">
            <nav className={`navigation ${menuOpen ? "open" : "closed"}`}>
              {/* Mobile Toggle Button */}
              <button
                className="menu-toggle"
                onClick={() => setMenuOpen(!menuOpen)}
              >
                {menuOpen ? "✖" : "☰"}
              </button>

              <ul className="nav-menus">
                <li className={location.pathname === "/" ? "active" : ""}>
                  <Link to="/" onClick={() => setMenuOpen(false)}>
                    Home
                  </Link>
                </li>

                <li
                  className={location.pathname === "/aboutus" ? "active" : ""}
                >
                  <Link to="/aboutus" onClick={() => setMenuOpen(false)}>
                    About Us
                  </Link>
                </li>

                <li className={location.pathname === "/shop" ? "active" : ""}>
                  <Link to="/shop" onClick={() => setMenuOpen(false)}>
                    Product
                  </Link>
                </li>

                <li
                  className={location.pathname === "/contact" ? "active" : ""}
                >
                  <Link to="/contact" onClick={() => setMenuOpen(false)}>
                    Contact Us
                  </Link>
                </li>

                <li className={location.pathname === "/legal" ? "active" : ""}>
                  <Link to="/legal" onClick={() => setMenuOpen(false)}>
                    Legal
                  </Link>
                </li>

                <li className={location.pathname === "/media" ? "active" : ""}>
                  <Link to="/media" onClick={() => setMenuOpen(false)}>
                    Media
                  </Link>
                </li>

                <li className={location.pathname === "/events" ? "active" : ""}>
                  <Link to="/events" onClick={() => setMenuOpen(false)}>
                    Events
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </header>

      {/* ======================= Middle Header End ========================= */}
      {/* ==================== Header Start Here ==================== */}
      <header
        className={`header bg-white border-bottom border-gray-100 ${scroll && "fixed-header"}`}
      >
        <div className="container container-lg">
          <nav className="header-inner d-flex justify-content-between gap-8">
            <div className="flex-align menu-category-wrapper">
              {/* Category Dropdown Start */}

              {/* Category Dropdown End  */}
              {/* Menu Start  */}
              <div className="header-menu d-lg-block d-none">
                {/* Nav Menu Start */}
                {/* <ul className="nav-menu flex-align ">
                  <li className="nav-menu__item">
                    <NavLink
                      to="/"
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      Home
                    </NavLink>
                  </li>
                  <li className="on-hover-item nav-menu__item ">
                    <Link to="/shop" className="nav-menu__link">
                      Category
                    </Link>
                  </li>

                  <li className="on-hover-item nav-menu__item has-submenu">
                    <Link to="#" className="nav-menu__link">
                      Blog
                    </Link>
                    <ul className="on-hover-dropdown common-dropdown nav-submenu scroll-sm">
                      <li className="common-dropdown__item nav-submenu__item">
                        <NavLink
                          to="/blog"
                          className={(navData) =>
                            navData.isActive
                              ? "common-dropdown__link nav-submenu__link hover-bg-neutral-100 activePage"
                              : "common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                          }
                        >
                          {" "}
                          Blog
                        </NavLink>
                      </li>
                      <li className="common-dropdown__item nav-submenu__item">
                        <NavLink
                          to="/blog-details"
                          className={(navData) =>
                            navData.isActive
                              ? "common-dropdown__link nav-submenu__link hover-bg-neutral-100 activePage"
                              : "common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                          }
                        >
                          {" "}
                          Blog Details
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-menu__item">
                    <NavLink
                      to="/contact"
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      Contact Us
                    </NavLink>
                  </li>
                </ul> */}
                {/* Nav Menu End */}
              </div>
              {/* Menu End  */}
            </div>
            {/* Header Right start */}
            {/* <div className="header-right flex-align">
              <Link
                to="/tel:01234567890"
                className="bg-main-600 text-white p-12 h-100 hover-bg-main-800 flex-align gap-8 text-lg d-lg-flex d-none"
              >
                <div className="d-flex text-32">
                  <i className="ph ph-phone-call" />
                </div>
                01- 234 567 890
              </Link>
              <div className="me-16 d-lg-none d-block">
                <div className="flex-align flex-wrap gap-12">
                  <button
                    onClick={handleSearchToggle}
                    type="button"
                    className="search-icon flex-align d-lg-none d-flex gap-4 item-hover"
                  >
                    <span className="text-2xl text-gray-700 d-flex position-relative item-hover__text">
                      <i className="ph ph-magnifying-glass" />
                    </span>
                  </button>
                {isLoggedIn && (
  <Link to="/wishlist" className="flex-align gap-4 item-hover">
    <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
      <i className="ph ph-heart" />
      <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
        {wishlistCount}
      </span>
    </span>
    <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
      Wishlist
    </span>
  </Link>
)}
                  <Link to="/cart" className="flex-align gap-4 item-hover">
                    <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                      <i className="ph ph-shopping-cart-simple" />
                      <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                        {cartCount}
                      </span>
                    </span>
                    <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                      Cart
                    </span>
                  </Link>
                </div>
              </div>
              <button
                onClick={handleMenuToggle}
                type="button"
                className="toggle-mobileMenu d-lg-none ms-3n text-gray-800 text-4xl d-flex"
              >
                {" "}
                <i className="ph ph-list" />{" "}
              </button>
            </div> */}
            {/* Header Right End  */}
          </nav>
        </div>
      </header>
      {/* ==================== Header End Here ==================== */}
    </>
  );
};

export default Header;
